import { EditNode, EditNodeToolbar } from "@react-admin/ra-tree";
import { SimpleForm } from "react-admin";
import { settings } from "app/settings";

const TreeNodeEdit = ({ name }) => {
  const FormComponent = settings.getUrlTreeComponent(name);

  return (
    <EditNode
      mutationMode="pessimistic"
      title="Меню елемент"
      mutationOptions={{ meta: { useFormData: false } }}
    >
      <SimpleForm toolbar={<EditNodeToolbar />}>
        <FormComponent />
      </SimpleForm>
    </EditNode>
  );
};

export default TreeNodeEdit;
